<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="10"
                md="8"
                sm="6"
            >
                <h3>Contractor</h3>
            </v-col>
            <v-col 
                style="text-align: right;"
                cols="6"
                lg="2"
                md="4"
                sm="6"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            :to="{ name: 'contractorForm', params: {id: 0} }"
                        >
                            New Contractor
                        </v-btn>
                    </template>
                    <span>New Contractor</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Quick Search"
                        prepend-inner-icon="mdi mdi-magnify"
                        single-line
                        outlined
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-row>            
            <v-col 
                cols="12"
                lg="12"
                md="12"
                sm="12"
            >
                <label>Category</label>
                <v-combobox
                    v-model="filter.contractorCategorySelected"
                    :items="listContractorCategory" 
                    item-text="contractorCategoryDescription"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="filterRegisters()"
                ></v-combobox>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredSearch"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item.action="{item}">
                        <ActionList 
                            :id="item.id" 
                            :link="'contractorForm'"
                            :showButtons="{
                                edit: true,
                                cancel: item.status === 1 ? true : false,
                                active: item.status === 0 ? true : false
                            }"
                            @confirmCancel="confirmCancel"
                            @confirmActive="confirmActive"   />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";

    export default ({

        components: {
            ActionList: ActionList,
            ActionDialog: ActionDialog
        },

        mixins: [Helpers],

        data: () => ({

            loading: false,

            filter: {
                fastSearch: '',
                contractorCategorySelected: null
            },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            headers: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Category", value: "contractorCategoryDescription", sortable: true },
                { text: "Name", value: "name", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            options: { rowsPerPage: 10, page: 1 },

            listContractor: [],
            listContractorFiltered: [],
            listContractorCategory: [],
        }),

        computed: {

            filteredSearch: function() {
                return this.listContractorFiltered.filter((contractorFilter) => {
                    
                    let filter = this.filter.fastSearch.toLowerCase();

                    var statusDescription = contractorFilter.statusDescription.toLowerCase().match(filter)
                    var contractorCategoryDescription = contractorFilter.contractorCategoryDescription.toLowerCase().match(filter)
                    var name = contractorFilter.name.toLowerCase().match(filter)
                    var id = contractorFilter.id.toString().match(filter);

                    if(statusDescription != null) { return statusDescription; } 
                    else if(contractorCategoryDescription != null) { return contractorCategoryDescription; } 
                    else if(name != null) { return name; } 
                    else { return id; }
                });
            }
        },

        methods: {
            async getLists() {
                const listContractorCategory = await this.$store.dispatch("contractorCategoryModule/ListTypeContractorCategory");

                this.listContractorCategory = listContractorCategory.filter(item => item.id >= 1);
            },
            
            async getRegisters() {

                this.listContractor = await this.$store.dispatch("contractorModule/List");
                this.listContractorFiltered = [...this.listContractor];
            },

            async filterRegisters() {

                let idContractorCategory = 0;
                let listFiltered = [...this.listContractor];

                if (this.filter.contractorCategorySelected != null && this.filter.contractorCategorySelected != undefined) {
                    idContractorCategory = this.filter.contractorCategorySelected.id;
                    listFiltered = listFiltered.filter(ser => ser.idContractorCategory == idContractorCategory);
                }

                this.listContractorFiltered = listFiltered;
            },

            confirmCancel(id) {

                this.statusId = 0;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will INACTIVATE this Contractor, confirm your decision?',
                    methodConfirm: this.cancel,
                    params: id
                };
            },

            async cancel(id) {

                let statusId = this.statusId;

                this.showLoading();

                let result = await this.$store.dispatch("contractorModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            confirmActive(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will ACTIVATE this Contractor, confirm your decision?',
                    methodConfirm: this.active,
                    params: id
                };

            },

            async active(id) {

                this.showLoading();
                let statusId = this.statusId;

                let result = await this.$store.dispatch("contractorModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            }

        },

        async created() {
            this.showLoading();

            await this.getLists();
            await this.getRegisters();

            this.hideLoading();
        }
    })
</script>
